import { render, staticRenderFns } from "./AdminPendingApproval.vue?vue&type=template&id=78858466&lang=pug&"
import script from "./AdminPendingApproval.vue?vue&type=script&lang=js&"
export * from "./AdminPendingApproval.vue?vue&type=script&lang=js&"
import style0 from "./AdminPendingApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports